import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ExercisesComponent} from './exercises/exercises.component'
import { TopicComponent } from './topic/topic.component';
import { TeacherGuard } from '../App/teacher-guard.service';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import {TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';

import { ImageCompressionComponent} from './image-compression/image-compression.component';
import { TImageCompressionComponent } from './t-image-compression/t-image-compression.component';

import { WordCompressionComponent} from './word-compression/word-compression.component';
import { TWordCompressionComponent } from './t-word-compression/t-word-compression.component';

import { WordDecompressionComponent} from './word-decompression/word-decompression.component';
import { TWordDecompressionComponent } from './t-word-decompression/t-word-decompression.component';

import { CreateImagesComponent} from './create-images/create-images.component';
import { TCreateImagesComponent } from './t-create-images/t-create-images.component';

import { NewImageCompressionComponent} from './new-image-compression/new-image-compression.component';
import { TNewImageCompressionComponent } from './t-new-image-compression/t-new-image-compression.component';

import { NewImageDecompressionComponent} from './new-image-decompression/new-image-decompression.component';
import { TNewImageDecompressionComponent } from './t-new-image-decompression/t-new-image-decompression.component';

import { DiscoverComponent } from './discover/discover.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';

import { LetterCompressionComponent } from './letter-compression/letter-compression.component';
import { TLetterCompressionComponent } from './t-letter-compression/t-letter-compression.component';

import { LetterDecompressionComponent } from './letter-decompression/letter-decompression.component';
import { TLetterDecompressionComponent } from './t-letter-decompression/t-letter-decompression.component';

import { CreateCompressionComponent } from './create-compression/create-compression.component';
import { TCreateCompressionComponent } from './t-create-compression/t-create-compression.component';

import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';

import { PlaygroundComponent } from './playground/playground.component';


const compressionRoutes: Routes = [
  { path: 'compression', component:TopicComponent,
  children : [
    { path: '', component: ExercisesComponent, pathMatch: 'full'},
    { path: 'exam/:id', component: ExamComponent},
    { path: 'exam/:id/evaluation', component: EvaluationComponent},
    { path: 'exam/:examid/openQuestion/:id', component: OpenQuestionComponent}, 
    { path: 'exam/:examid/multipleChoice/:id', component: MultipleChoiceComponent},
    { path: 'openQuestion/:id', component: OpenQuestionComponent}, 
    { path: 'multipleChoice/:id', component: MultipleChoiceComponent},
    { path: 'playground', component: PlaygroundComponent},

   
   { path: 'imageCompression/:id', component: ImageCompressionComponent},
   { path: 'exam/:examid/imageCompression/:id', component: ImageCompressionComponent},
   
   { path: 'wordCompression/:id', component: WordCompressionComponent},
   { path: 'exam/:examid/wordCompression/:id', component: WordCompressionComponent},
   
   { path: 'wordDecompression/:id', component: WordDecompressionComponent},
   { path: 'exam/:examid/wordDecompression/:id', component: WordDecompressionComponent},
   
   { path: 'createImages/:id', component: CreateImagesComponent},
   { path: 'exam/:examid/createImages/:id', component: CreateImagesComponent},
   
   { path: 'newImageCompression/:id', component: NewImageCompressionComponent},
   { path: 'exam/:examid/newImageCompression/:id', component: NewImageCompressionComponent},
   
   { path: 'newImageDecompression/:id', component: NewImageDecompressionComponent},
   { path: 'exam/:examid/newImageDecompression/:id', component: NewImageDecompressionComponent},
   
   { path: 'discover/:id', component: DiscoverComponent},
   { path: 'exam/:examid/discover/:id', component: DiscoverComponent},
   
   { path: 'letterCompression/:id', component: LetterCompressionComponent},
   { path: 'exam/:examid/letterCompression/:id', component: LetterCompressionComponent},
   
   { path: 'letterDecompression/:id', component: LetterDecompressionComponent},
   { path: 'exam/:examid/letterDecompression/:id', component: LetterDecompressionComponent},
   
   { path: 'createCompression/:id', component: CreateCompressionComponent},
   { path: 'exam/:examid/createCompression/:id', component: CreateCompressionComponent},
   
   { path: 'example/:id', component: ExampleComponent},
   { path: 'exam/:examid/example/:id', component: ExampleComponent}
   
  ] },
  {path: 'teacher/compression', canActivate: [TeacherGuard], canActivateChild:[TeacherGuard], component: TopicComponent,
    children:[
    { path: '', component: TExercisesComponent, pathMatch: 'full'},
    { path: 'openQuestion', component: TOpenQuestionComponent}, 
    { path: 'multipleChoice', component: TMultipleChoiceComponent},
    { path: 'openQuestion/:id', component: TOpenQuestionComponent}, 
    { path: 'multipleChoice/:id', component: TMultipleChoiceComponent},
    { path: 'allExercisesTeacher', component: TAllExercisesComponent},
    { path: 'allExamsTeacher', component: TAllExamsComponent},

    { path: 'imageCompression', component: TImageCompressionComponent},
    { path: 'imageCompression/:id', component: TImageCompressionComponent},

    { path: 'wordCompression', component: TWordCompressionComponent},
    { path: 'wordCompression/:id', component: TWordCompressionComponent},

    { path: 'wordDecompression', component: TWordDecompressionComponent},
    { path: 'wordDecompression/:id', component: TWordDecompressionComponent},

    { path: 'createImages', component: TCreateImagesComponent},
    { path: 'createImages/:id', component: TCreateImagesComponent},

    { path: 'newImageCompression', component: TNewImageCompressionComponent},
    { path: 'newImageCompression/:id', component: TNewImageCompressionComponent},

    { path: 'newImageDecompression', component: TNewImageDecompressionComponent},
    { path: 'newImageDecompression/:id', component: TNewImageDecompressionComponent},

    { path: 'discover', component: TDiscoverComponent},
    { path: 'discover/:id', component: TDiscoverComponent},

    { path: 'letterCompression', component: TLetterCompressionComponent},
    { path: 'letterCompression/:id', component: TLetterCompressionComponent},

    { path: 'letterDecompression', component: TLetterDecompressionComponent},
    { path: 'letterDecompression/:id', component: TLetterDecompressionComponent},

    { path: 'createCompression', component: TCreateCompressionComponent},
    { path: 'createCompression/:id', component: TCreateCompressionComponent},

    { path: 'example', component: TExampleComponent},
    { path: 'example/:id', component: TExampleComponent},
    
  

    { path: 'exam', component: TExamComponent},
    { path: 'exam/:examid', component: TExamComponent, pathMatch: 'full'},
      { path: 'exam/:examid/allExercisesTeacher', component: TAllExercisesComponent},
      { path: 'exam/:examid/openQuestion', component: TOpenQuestionComponent},
      { path: 'exam/:examid/openQuestion/:id', component: TOpenQuestionComponent},
      { path: 'exam/:examid/multipleChoice', component: TMultipleChoiceComponent},
      { path: 'exam/:examid/multipleChoice/:id', component: TMultipleChoiceComponent},

      { path: 'exam/:examid/imageCompression', component: TImageCompressionComponent},
      { path: 'exam/:examid/imageCompression/:id', component: TImageCompressionComponent},

      { path: 'exam/:examid/wordCompression', component: TWordCompressionComponent},
      { path: 'exam/:examid/wordCompression/:id', component: TWordCompressionComponent},

      { path: 'exam/:examid/wordDecompression', component: TWordDecompressionComponent},
      { path: 'exam/:examid/wordDecompression/:id', component: TWordDecompressionComponent},

      { path: 'exam/:examid/createImages', component: TCreateImagesComponent},
      { path: 'exam/:examid/createImages/:id', component: TCreateImagesComponent},

      { path: 'exam/:examid/newImageCompression', component: TNewImageCompressionComponent},
      { path: 'exam/:examid/newImageCompression/:id', component: TNewImageCompressionComponent},

      { path: 'exam/:examid/newImageDecompression', component: TNewImageDecompressionComponent},
      { path: 'exam/:examid/newImageDecompression/:id', component: TNewImageDecompressionComponent},

      { path: 'exam/:examid/discover', component: TDiscoverComponent},
      { path: 'exam/:examid/discover/:id', component: TDiscoverComponent},

      { path: 'exam/:examid/letterCompression', component: TLetterCompressionComponent},
      { path: 'exam/:examid/letterCompression/:id', component: TLetterCompressionComponent},

      { path: 'exam/:examid/letterDecompression', component: TLetterDecompressionComponent},
      { path: 'exam/:examid/letterDecompression/:id', component: TLetterDecompressionComponent},

      { path: 'exam/:examid/createCompression', component: TCreateCompressionComponent},
      { path: 'exam/:examid/createCompression/:id', component: TCreateCompressionComponent},

      { path: 'exam/:examid/example', component: TExampleComponent},
      { path: 'exam/:examid/example/:id', component: TExampleComponent}
      
     

  ] }
];

@NgModule({
  imports: [
      RouterModule.forChild(compressionRoutes)
  ],
  declarations: [],
  exports: [
    RouterModule]
})
export class TopicRoutingModule { }
